import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/modules/shared.module';
import { CalloutComponent } from './callout.component';

const components = [
  CalloutComponent,
];

@NgModule({
  declarations: [
    ...components,
  ],
  imports: [
    SharedModule,
    OverlayModule,
  ],
  exports: [
    ...components,
    OverlayModule,
  ],
})
export class CalloutModule {}
